import { render, staticRenderFns } from "./ItemConfirm.vue?vue&type=template&id=7c590032&scoped=true&"
import script from "./ItemConfirm.vue?vue&type=script&lang=js&"
export * from "./ItemConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ItemConfirm.vue?vue&type=style&index=0&id=7c590032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c590032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VImg,VRow})
